module.exports = __webpack_public_path__ + "media/images/matchdaySelector__md2--selected-5d845313dc9ffe2e90b326905701fec7.png";